module.exports = __webpack_public_path__ + "statics/img/yhz3m.19d9a51c.png";